import { render, staticRenderFns } from "./BcelTransaction.vue?vue&type=template&id=30ebd03b"
import script from "./BcelTransaction.vue?vue&type=script&lang=js"
export * from "./BcelTransaction.vue?vue&type=script&lang=js"
import style0 from "./BcelTransaction.vue?vue&type=style&index=0&id=30ebd03b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports